import { getHomeLoansDashboardRuntimeConfig } from 'src/services/config/getHomeLoansDashboardRuntimeConfig';

export const getServerURLs = () => {
    const { publicRuntimeConfig } = getHomeLoansDashboardRuntimeConfig();
    const { services } = publicRuntimeConfig;
    return services;
};
